// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2KbOc","log":"ModalInventoryLogs_log__vAf9F","date":"ModalInventoryLogs_date___0f0U","userName":"ModalInventoryLogs_userName__3R17Q"};